<template>
    <report-line-text :text="text"></report-line-text>
</template>

<script>
import reportLineText from './reportLineText.vue';
import { mapGetters } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { reportUtils } from '@/features/report/lib/reportUtils';
import { nodes } from '@/globals/nodes';
import { LabelAnnotation, LabelAnnotationLocation } from '@/features/report/models';

export default {
    name: 'dentesSegReportLineText',
    components: {
        reportLineText
    },
    props: {
    },
    computed: {
        ...mapGetters([
            'GET_dentesAusentesText',
            'GET_dentesPresentesText',
            'GET_nodesArray',
            'GET_selectedDenticaoReportNode'
        ]),

        layerDentesSegNode() {
            return this.GET_nodesArray.find(node => node.id == 'layer_dentesSeg');
        },

        currentDenticao() {
            return this.GET_selectedDenticaoReportNode?.id;
        },

        text() {
            if (this.GET_dentesAusentesText.length == 0) {
                return this.layerDentesSegNode.report.normal;
            } else if (this.GET_dentesPresentesText.length == 0) {
                return 'Todos os dentes estão ausentes (desdentado total).';
            } else {
                switch (this.currentDenticao) {
                    case gConsts.denticao.types.PERMANENTE:
                        if (this.GET_dentesAusentesText.length < this.GET_dentesPresentesText.length) {
                            return 'Dentes ausentes: ' + this.getDentesReportText(this.GET_dentesAusentesText)+ '.';
                        } else {
                            return 'Dentes presentes: ' + this.getDentesReportText(this.GET_dentesPresentesText) + '.';
                        }
                    case gConsts.denticao.types.MISTA:
                    case gConsts.denticao.types.DECIDUA:
                        return 'Dentes presentes: ' + this.getDentesReportText(this.GET_dentesPresentesText) + '.';
                }
            }
            return '';
        },
    },
    methods: {
        getDenteItemElementText(dente) {
            return reportUtils.getAnnotationItemElementText({ id: `lb_dente${dente}`, reportText: dente });
        },
        getDentesReportText(dentes) {
            return reportUtils.getAnnotationsText(dentes.map(dente => {
                const denteId = `lb_dente${dente}`;
                const denteNode = nodes.getNode(denteId);
                const color = gConsts.ui.prettyColors[denteNode?.layout?.color?.toLowerCase()] || denteNode?.layout?.color;
                const text = reportUtils.getNodeReportText(denteNode);
                const annotation = new LabelAnnotation(
                    gConsts.node.report.annotation.types.TOOTH,
                    'dentes_seg_' + denteId,
                    new LabelAnnotationLocation(
                        null,
                        [],
                        [{ id: denteId, text: text, color: color }]
                    ),
                    []
                );

                annotation.reportText = text;
                
                return annotation;
            }));
        }
    }
}
</script>